import { render, staticRenderFns } from "./OrganismAlertModification.vue?vue&type=template&id=3a97b650&scoped=true&"
import script from "./OrganismAlertModification.vue?vue&type=script&lang=js&"
export * from "./OrganismAlertModification.vue?vue&type=script&lang=js&"
import style0 from "./OrganismAlertModification.vue?vue&type=style&index=0&id=3a97b650&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a97b650",
  null
  
)

export default component.exports